import styled from "styled-components";

import {
  pageHeaderHDBreakpoint,
  pageHeaderMobileBreakpoint,
} from "pages/[tenant]/console/components/molecules/PageHeader/utils";

export const PageHeaderSubtitleContainer = styled.div`
  color: ${({ theme }) => theme.console.pageSubtitleColor} !important;
  font: 400 1.125rem/1.6875rem "Inter";

  max-width: 36.125rem; // 476px

  grid-column: 1;

  margin-bottom: 2.7rem;

  height: 100%;

  @media (max-width: ${pageHeaderHDBreakpoint}px) {
    font: 400 1rem/1.6875rem "Inter";
  }

  @media (max-width: ${pageHeaderMobileBreakpoint}px) {
    grid-row: 2;
    margin-bottom: 1rem;
  }
`;
